import { Box, Grid, Image } from '@chakra-ui/react';
import { Card, CardContent } from '@mesh.ai/rabbit';

import { Radio } from 'uiToolkitV1/Radio';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

type Props = {
  heading: string;
  subHeading: string;
  imgSrc: string;
  isChecked?: boolean;
  ConditionComponent?: React.ReactNode;
  radioName: string;
  onRadioChange?: (value: string) => void;
  isLastCard?: boolean;
};

const ReviewTypeCard = ({
  heading,
  subHeading,
  imgSrc,
  isChecked = false,
  ConditionComponent,
  radioName,
  onRadioChange,
  isLastCard,
}: Props) => (
  <Card style={{ marginBottom: isLastCard ? '0px' : '10px' }}>
    <CardContent>
      <Grid templateColumns="auto 1fr auto">
        <Image src={imgSrc} mr="16px" height="80px" width="80px" />
        <Box>
          <TextBodyMedium bold mt="4px">
            {heading}
          </TextBodyMedium>
          <TextBodyMedium mt="4px">{subHeading}</TextBodyMedium>
        </Box>
        <Box alignSelf="center">
          <Radio onChange={onRadioChange} name={radioName} isChecked={isChecked} />
        </Box>
      </Grid>
      {isChecked && !!ConditionComponent && <Box mt="12px">{ConditionComponent}</Box>}
    </CardContent>
  </Card>
);

export { ReviewTypeCard };
